/* @flow */

export default class UpdateCompanyUserRequest {
  companyId: number;
  companyUserId: number;
  functionName: string;
}
